"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RISE_STRATEGIST_TEMPLATES = exports.RISE_STRATEGIST_TEMPLATES_MD = void 0;
exports.RISE_STRATEGIST_TEMPLATES_MD = {
    'Initial Strategy Meeting (ISM)': `* Introductions - Strategist, Student, & Rise\n
* Getting to Know You - Academics & Extracurriculars\n
* Introduction to University Admissions\n
* Program Staging\n
* Setting Up Your Crimson App\n
* Scheduling & Housekeeping`,
    'Parent Alignment Meeting (PAM)': `* Student Alignment\n
* Program Focus\n
* Crimson Experience - Crimson Community, Rise Readers, Rise Parent Packet
  `,
    'Pathfinder Meeting': `* Pathfinder Introduction\n
* First Goals\n
* First Lesson\n
* Crimson Community'`,
    'Meeting: Learning Skills': '* N/A',
    'Meeting: Personal Skills': '* N/A',
    'Meeting: Academic or Career Planning': '* N/A',
    'Meeting: Extracurriculars': '* N/A',
    'Meeting: Other': '* N/A',
    'Final Meeting': `* Self-Assessment\n
* Moving Forward - Academics, Extracurriculars, Personal Life\n
* Moving Forward - Crimson Core\n
* Graduation Report`,
    Other: '* N/A',
};
exports.RISE_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions - Strategist, Student, & Rise',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Getting to Know You - Academics & Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Introduction to University Admissions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Program Staging',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Setting Up Your Crimson App',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Scheduling & Housekeeping',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Parent Alignment Meeting (PAM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Student Alignment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Program Focus',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Crimson Experience - Crimson Community, Rise Readers, Rise Parent Packet',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Roadmap Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Review Roadmap and Ensure Student Knows How it Works',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 Immediate New Goals to Add to the Roadmap',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Establish Expectations of How the Roadmap and Student Centre Will Be Used Throughout Strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'First Lesson',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Crimson Community',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Meeting: Learning Skills': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Meeting: Personal Skills': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Meeting: Academic or Career Planning': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Meeting: Extracurriculars': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Meeting: Other': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Final Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Self-Assessment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Moving Forward - Academics, Extracurriculars, Personal Life',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Moving Forward - Crimson Core',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Graduation Report',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=rise-strategist.js.map